import React from 'react';

import {MediumText} from 'shared/components/text';

import styled from 'styled-components';
import Loading from 'shared/migration-components/loading';
import Empty from 'shared/migration-components/empty';
import useAddressesByPhone from 'modules/addresses/hooks/use-addresses-by-phone';
import useCart from '../util/use-cart';
import CartUserAddress from './cart-user-address';
import Row from 'shared/components/row';
import Button from 'shared/migration-components/button';
import {useNavigate} from 'react-router-dom';

const CartAddresses: React.FC = () => {
  const {cart} = useCart();
  const navigate = useNavigate();

  const {data, isLoading} = useAddressesByPhone(cart?.guestUser?.phone);

  return (
    <Container>
      <Row justifyContent="space-between">
        <MediumText size="large">Endereços</MediumText>
        <Button
          title="NOVO ENDEREÇO"
          size="extra-small"
          onClick={() => navigate('create')}
        />
      </Row>
      {isLoading && <Loading flex />}
      {data?.length === 0 && !isLoading && (
        <Empty text="Nenhum endereço cadastrado" />
      )}
      {!isLoading && data && data.length > 0 && (
        <Content>
          {data?.map((address) => (
            <CartUserAddress key={address.id} {...address} />
          ))}
        </Content>
      )}
    </Container>
  );
};

export default CartAddresses;

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 35px 15px 30px 15px;
  overflow-y: auto;
  gap: 30px;
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: white;
  gap: 15px;
`;
